export const SAVE_TO_CLIPBOARD = 'SAVE_TO_CLIPBOARD';
export type SAVE_TO_CLIPBOARD = typeof SAVE_TO_CLIPBOARD;